import { RouteObject } from 'react-router-dom';
import DashboardPage from '@/pages/dashboard/page';
import ContentPage from '@/pages/content/page';
import AIProcessingPage from '@/pages/ai-processing/page';
import LayoutEnginePage from '@/pages/layout-engine/page';
import ExportPage from '@/pages/export/page';
import SettingsPage from '@/pages/settings/page';
import LandingPage from '@/pages/landing/page';
import ArticlePage from '@/pages/article/page';
import EditorPage from '@/pages/editor/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <LandingPage /> },
  { path: '/article/:id', element: <ArticlePage /> },
  { path: '/dashboard', element: <DashboardPage /> },
  { path: '/editor', element: <EditorPage /> },
  { path: '/content', element: <ContentPage /> },
  { path: '/ai-processing', element: <AIProcessingPage /> },
  { path: '/layout-engine', element: <LayoutEnginePage /> },
  { path: '/export', element: <ExportPage /> },
  { path: '/settings', element: <SettingsPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
